import { render, staticRenderFns } from "./addAttendanceClassesStaffList.vue?vue&type=template&id=254cd376&scoped=true"
import script from "./addAttendanceClassesStaffList.vue?vue&type=script&lang=js"
export * from "./addAttendanceClassesStaffList.vue?vue&type=script&lang=js"
import style0 from "./addAttendanceClassesStaffList.vue?vue&type=style&index=0&id=254cd376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254cd376",
  null
  
)

export default component.exports